<script>
import { isLogin } from '@/features/user'
import { getPendingOrderCount } from '@/api/loan'

export default {
  async mounted() {
    //  未登录 或 不为个人
    if (!isLogin()) return
    // 重复提示标识
    if (sessionStorage.getItem('orderTips')) return
    // 用户信息未获取标识
    if (!sessionStorage.getItem('userInfoGetFlag')) return

    // 获取草稿订单数量
    let countNumMap = await getPendingOrderCount()
      .then(res => (res.data.code === 0 ? res.data.data : null))
      .catch(() => {})

    // 草稿订单数量   退回待补充订单数量
    const { draftCount, requireMaterialCount } = countNumMap

    if (!draftCount && !requireMaterialCount) return

    const draftText = draftCount ? `${draftCount}笔草稿状订单` : ''
    const supplementText = requireMaterialCount ? `${requireMaterialCount}笔需补充资料订单` : ''
    const dot = draftText && supplementText ? '、' : ''

    sessionStorage.setItem('orderTips', true)

    this.$confirm(`您有${draftText}${dot}${supplementText}，请问是否立即办理？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'info'
    })
      .then(() => {
        this.$router.push({ name: 'loan' })
      })
      .catch(() => {})
  },
  render() {
    return ''
  }
}
</script>

<style lang="scss" scoped></style>
